import { FC } from 'react';
import { ClearingBankTabs } from '@widgets/ClearingBankTabs';

const ClearingBankPage: FC = () => {
    return <ClearingBankTabs />;
};

export default ClearingBankPage;
